import { ICreateDefault, BaseModel } from '../../../'
import { ModelFactory } from '../../../data/factories'

export class CreateDefaultStrategy implements ICreateDefault {

  constructor(
    private _modelFactory: ModelFactory
  ) {}

  public create(modelType: string): BaseModel {
    return this._modelFactory.instantiateClass(modelType)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/factories/strategies/create-default/create-default.strategy.ts